export const retailer = {
  name: 'Growcer',
  tagline: 'Fresh & Healthy Organic Food',
  phone: '545-548-5687',
  supportEmail: 'support@growcer.com',
  currency: 'USD',
  language: 'English',
  heroCopy: 'Sale up to 30% off',
  heroSubcopy: 'Free shipping on all orders — we deliver, you enjoy.',
  address: '8 S Newyork, USA',
  hours: 'Everyday from 10:00 AM to 08:00 PM'
};

export const features = [
  { title: 'Free Shipping', desc: 'Free shipping on all orders', icon: '🚚' },
  { title: 'Customer Support 24/7', desc: 'Instant access to support', icon: '💬' },
  { title: '100% Secure Payment', desc: 'We ensure your money is safe', icon: '🔒' },
  { title: 'Money-Back Guarantee', desc: '30-day money-back guarantee', icon: '💵' }
];

export const heroSlides = [
  {
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1960&h=920&fit=crop',
    alt: 'Seasonal produce and greens on wooden table',
    label: 'Seasonal Harvest'
  },
  {
    image: 'https://images.unsplash.com/photo-1580915411960-7b12e1e0125e?w=1960&h=920&fit=crop',
    alt: 'Fresh bread, grains, and bottles of olive oil',
    label: 'Artisan Pantry'
  },
  {
    image: 'https://images.unsplash.com/photo-1506807803488-8eafc15316c0?w=1960&h=920&fit=crop',
    alt: 'Colorful fruits and vegetables in baskets',
    label: 'Market Morning'
  }
];

export const categories = [
  { name: 'Vegetables', image: 'https://i.imgur.com/yNJ7fLa.png' },
  { name: 'Fruits', image: 'https://i.imgur.com/kC1UjAh.png' },
  { name: 'Drinks', image: 'https://i.imgur.com/wNjKXsG.png' },
  { name: 'Fresh Nuts', image: 'https://i.imgur.com/YuFkJXG.png' },
  { name: 'Fresh Fish', image: 'https://i.imgur.com/YEW1KzZ.png' },
  { name: 'Meat', image: 'https://i.imgur.com/OjUawJl.png' },
  { name: 'Bakery', image: 'https://i.imgur.com/6tp30gW.png' },
  { name: 'Dairy', image: 'https://i.imgur.com/Vm77mlX.png' }
];

export const banners = [
  { title: 'Free delivery over $50', desc: 'Shop $50 product and get free delivery anywhere.', cta: 'Shop Now', tone: 'primary' },
  { title: 'Organic Food', desc: 'Save up to 60% off on your first order', cta: 'Order Now', tone: 'accent' },
  { title: 'Winter Discount', desc: 'Get an add-on item for other ads', cta: 'View Deals', tone: 'promo' }
];

export const products = [
  { name: 'Green Capsicum', price: 4.40, unit: '/1kg', rating: 4.5, tag: 'Vegetables', image: 'https://i.imgur.com/HazlEpC.png' },
  { name: 'Fresh Banana', price: 3.20, unit: '/12 pcs', rating: 4.8, tag: 'Fruits', image: 'https://i.imgur.com/FHcrRZb.png' },
  { name: 'Fresh Red Chilli', price: 2.80, unit: '/500g', rating: 4.6, tag: 'Vegetables', image: 'https://i.imgur.com/xmKMKpA.png' },
  { name: 'Fresh Pomegranate', price: 3.60, unit: '/6 pcs', rating: 4.7, tag: 'Fruits', image: 'https://i.imgur.com/Tc5pP7e.png' },
  { name: 'Fresh Kiwi', price: 4.10, unit: '/6 pcs', rating: 4.5, tag: 'Fruits', image: 'https://i.imgur.com/qe6fBk6.png' },
  { name: 'Orange Soft Drink', price: 1.85, unit: '/1L', rating: 4.2, tag: 'Drinks', image: 'https://i.imgur.com/GYnWWMK.png' },
  { name: 'Salted Cashews', price: 5.20, unit: '/400g', rating: 4.9, tag: 'Fresh Nuts', image: 'https://i.imgur.com/5C6cRCN.png' }
];

export const ads = {
  list: [
    { id: 'weekly-ad', title: 'Weekly Ad', date: 'Nov 6 - Nov 12', summary: 'Fresh deals on produce, dairy, and pantry staples.', badge: 'In-store' },
    { id: 'holiday-specials', title: 'Holiday Specials', date: 'Nov 20 - Nov 27', summary: 'Seasonal desserts, roasts, and party trays.', badge: 'Limited' },
    { id: 'organic-focus', title: 'Organic Focus', date: 'Dec 1 - Dec 7', summary: 'Certified organic veggies and juices.', badge: 'Member' }
  ],
  items: [
    { name: 'Anjou Pears', price: '1.29/lb', limit: 'Limit 4', info: 'Crisp, sweet, locally sourced pears.' },
    { name: 'Grass-fed Ground Beef', price: '5.99/lb', limit: 'Limit 3', info: '80/20 blend, no antibiotics.' },
    { name: 'Sourdough Boule', price: '2 for $6', limit: 'No limit', info: 'Baked daily, starter from 1988.' },
    { name: 'Cold Brew Concentrate', price: '$9.99', limit: 'Limit 2', info: 'Makes 8 servings, smooth and balanced.' }
  ]
};

export const locations = [
  { id: 'river-market', name: 'River Market', address: '12 River Rd, Springfield, IL', phone: '217-555-0188', hours: 'Mon-Sun 7a - 9p' },
  { id: 'uptown', name: 'Uptown', address: '88 Lake Ave, Springfield, IL', phone: '217-555-0134', hours: 'Mon-Sat 8a - 10p' }
];

export const recipes = [
  { title: 'Tuscan Kale Salad', desc: 'Citrus dressing, toasted almonds, parmesan.', time: '20 mins' },
  { title: 'Sheet Pan Salmon', desc: 'Garlic herb butter, asparagus, lemon.', time: '30 mins' },
  { title: 'Roasted Veggie Bowl', desc: 'Quinoa, roasted peppers, feta, tahini.', time: '25 mins' }
];

export const events = [
  { title: 'Local Vendor Fair', date: 'Dec 5, 10a - 2p', desc: 'Meet local farmers and try fresh samples.' },
  { title: 'Knife Skills 101', date: 'Dec 12, 6p', desc: 'Free class with our culinary team.' }
];

export const notifications = [
  { title: 'Curbside pickup now available', desc: 'Order online and we will bring groceries to your car.' },
  { title: 'Text alerts', desc: 'Get a heads up when weekly ads go live.' }
];

export const spotlights = [
  { title: 'Partnering with local growers', desc: 'We reinvest 5% of profits into local farms.' },
  { title: 'Plastic-free aisles', desc: 'Refill stations for nuts, seeds, and coffee beans.' }
];

export const footerLinks = {
  accounts: ['My Account', 'Orders', 'Wishlist', 'Gift Cards'],
  useful: ['Coupons', 'Careers', 'Vendor Portal', 'Press'],
  help: ['Shipping & Delivery', 'Returns & Refunds', 'Store Feedback', 'Contact Us']
};

export const socialLinks = [
  { label: 'Facebook', url: 'https://facebook.com', icon: '📘' },
  { label: 'Instagram', url: 'https://instagram.com', icon: '📸' },
  { label: 'Twitter', url: 'https://twitter.com', icon: '🐦' },
  { label: 'YouTube', url: 'https://youtube.com', icon: '▶️' }
];

// Coupons data
export const coupons = [
  {
    id: '1',
    title: "$2 Off Fresh Produce",
    description: "Save on $10 or more of fresh fruits & vegetables",
    expires: "Expires in 5 days",
  },
  {
    id: '2',
    title: "Buy 2 Get 1 Free Dairy",
    description: "Mix and match eligible dairy products",
    expires: "Expires in 3 days",
  },
  {
    id: '3',
    title: "$5 Off Organic Meat",
    description: "On purchases of $25 or more",
    expires: "Expires in 7 days",
  },
  {
    id: '4',
    title: "20% Off Bakery Items",
    description: "Fresh baked goods every morning",
    expires: "Expires in 2 days",
  },
];

// Quick access features
export const quickAccessFeatures = [
  { icon: "🏪", title: "Shop Online", description: "Browse and order from home" },
  { icon: "📱", title: "Mobile App", description: "Shop on the go" },
  { icon: "🎫", title: "Digital Coupons", description: "Clip & save instantly" },
  { icon: "🚗", title: "Curbside Pickup", description: "We load your car" },
  { icon: "🏡", title: "Home Delivery", description: "Fresh to your door" },
  { icon: "⭐", title: "Rewards Program", description: "Earn points on every purchase" },
];
